import moment from 'moment';
import queryString from 'query-string';

export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export function numberWithCommas (number) {
  var parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export function isEmpty (str) {
  return (!str || str.trim().length === 0);
}
export function isEmptyArray (array) {
  return !array || array.length === 0;
}

export const filterString = (filter) => {
  // console.log(filter)
  if (filter && filter.length > 0) { return filter.join(','); }
  return undefined;
};

export function toUpper (str) {
  if (!isEmpty(str)) {
    return str.toUpperCase();
  }
  return str;
};

export function roundNumber (value, roundToDigit) {
  value = parseFloat(value);
  value = value.toFixed(roundToDigit);
  return value;
}

export function formatDate (dateStr, inputFormat, outputFormat) {
  if (dateStr && inputFormat && outputFormat) {
    return moment(dateStr, inputFormat).format(outputFormat);
  }
  return '';
};

export function formatPercent (value) {
  value = parseFloat(value);
  if (isNaN(value)) return 0;
  value = numberWithCommas(value.toFixed(2));
  if (value === '-0.00') value = '0.00';
  if (value.length > 0) value += '%';
  return value;
}

export function formatSpecialPrice (value) {
  value = parseFloat(value);
  if (isNaN(value) || value === 0) return '0';
  if (value >= 1) { value = numberWithCommas(value.toFixed(2)); } else {
    value = numberWithCommas(value.toFixed(4));
  }

  return value;
}

export function formatDollar (value) {
  value = parseFloat(value);
  if (isNaN(value)) return 0;
  value = numberWithCommas(value.toFixed());
  if (value === '-0') value = '0';
  if (value.length > 0) value = '$' + value;
  return value;
}

export function getQueryString(queryParams = {}) {
  return queryString.stringify(queryParams);
}

export function formatChartSummaryData (summaryData, property, maxProperty) {
  if (summaryData && summaryData[property]) {
    const data = summaryData[property];
    // fill out empty venue with 0 value
    const venues = ['ARCA', 'ECN', 'Link ATS', 'CICF', 'IDQS'];
    let maxValue = 0;
    data.forEach(function (item, index) {
      let total = 0;
      venues.forEach(function (venue, venueIndex) {
        if (!item.hasOwnProperty(venue)) {
          item[venue] = 0;
        }
        total += item[venue];
      });
      maxValue = Math.max(maxValue, total);
      item.total = total;
    });
    summaryData[maxProperty] = maxValue;
    summaryData[property] = data;
  }
}

export function getMaxScaleValueOption2 (value) {
  let maxScaleValue = 0;
  if (value) {
    const zeroNeeded = value.toString().length + 1;
    const startValueString = '1' + new Array(zeroNeeded).join('0');
    const startValue = parseInt(startValueString);
    maxScaleValue = value + (startValue - value % startValue);
  }
  return maxScaleValue;
}

export function getMaxScaleValue (value) {
  let maxScaleValue = 0;
  if (value) {
    const zeroNeeded = value.toString().length;
    const startValueString = '5' + new Array(zeroNeeded).join('0');
    const startValue = parseInt(startValueString);
    maxScaleValue = startValue;
    while (value > maxScaleValue) {
      maxScaleValue = maxScaleValue * 2;
    }
  }
  return maxScaleValue;
}
